// extracted by mini-css-extract-plugin
module.exports = {"aboutDetailText":"aboutDetails_aboutDetailText__23lkg","boldText":"aboutDetails_boldText__3Tlvc","xSmallText":"aboutDetails_xSmallText__2qEYK"};